import React from 'react';
import './Footer.css';

const Footer = () => {
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Dijikopi",
    "image": "https://www.dijikopi.com.tr/logo192.png",
    "url": "https://www.dijikopi.com.tr/",
    "telephone": "+90 532 484 0907",
    "email": "info@dijikopi.com.tr",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Kiremithane Mahallesi, 4406 Sokak, Müzeyyen Boro İşhanı, 5/34, Akdeniz, Mersin, Turkey",
      "addressLocality": "Mersin",
      "addressCountry": "TR"
    },
    "priceRange": "$$",
    "description": "Dijikopi, Mersin'de fotokopi tamiri, yazıcı kiralama, toner dolumu, dijital baskı ve teknik servis hizmetleri sunar.",
    "openingHours": "Mo-Fr 07:30-19:00",
    "sameAs": [
      "https://www.facebook.com/dijikopi",
      "https://www.instagram.com/dijikopi"
    ]
  };

  return (
    <footer className="footer">
      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>

      <div className="footer-content">
        <div className="footer-info">
          <h3>Dijikopi</h3>

          <p>
            Adres: Kiremithane Mahallesi, 4406 Sokak, Müzeyyen Boro İşhanı,
            5/34, Akdeniz, Mersin, Turkey
          </p>

          <p>
            Telefon: <a href="tel:+905324840907">+90 532 484 0907</a>
          </p>

          <p>
            E-posta: <a href="mailto:info@dijikopi.com.tr">info@dijikopi.com.tr</a>
          </p>

          <p>
            Çalışma Saatleri: Pazartesi - Cuma 07:30 - 19:00 (Haftasonu Kapalıdır.)
          </p>
          

        </div>

        <div className="footer-links">
          <a href="#about">Hakkımızda</a>
          <a href="#services">Hizmetler</a>
          <a href="#location">Konum</a>
          <a href="#contact">İletişim</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Dijikopi. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  );
};

export default Footer;